import React from "react";
import SignupContainer from "../components/signupContainer";
import loader from "../utils/Helper";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";
import { Link, useNavigate } from "react-router-dom";
const Login = () => {

    const [open, setOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState(false);
    const [message, setMessage] = React.useState(false);
  function SlideTransition(props) {
    return <Slide {...props} direction="left" />;
  }
  
  const handleClose = async () => {
    setOpen(false);
  };

  return (
     <div className="bg-color">
               <Snackbar
                 open={open}
                 autoHideDuration={8000}
                 onClose={handleClose}
                 anchorOrigin={{ vertical: "top", horizontal: "right" }}
                 TransitionComponent={SlideTransition}
               >
                 <Alert
                   onClose={handleClose}
                   severity= {severity}
                   variant="filled"
                   sx={{ width: "100%" }}
                 >
                   {message}
                 </Alert>
               </Snackbar>
               <div class="page">
                 <div class="brand">
                   <img
                     src="/newlogo.png"
                     className="logoImage"
                     alt="Logo"
                   />
                 </div>
         
                 <section class="content">
                   <div class="hero">
                     <h1>
                       Your Trusted Partner
                       <br />
                       in <span>Tax Solutions</span>
                     </h1>
         
                     <p>
                       Our multidisciplinary team of experienced Chartered Accountants,
                       Advocates, Lawyers and Company Secretaries provides comprehensive
                       solutions.
                     </p>
         
                     <div class="features">
                       <div class="feature">
                         <svg
                           viewBox="0 0 24 24"
                           fill="none"
                           stroke-width="1.8"
                           stroke-linecap="round"
                           stroke-linejoin="round"
                         >
                           <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                           <circle cx="10" cy="7" r="4" />
                           <path d="M20 8v6" />
                           <path d="M23 11h-6" />
                         </svg>
                         Expert Team
                       </div>
         
                       <div class="feature">
                         <svg
                           viewBox="0 0 24 24"
                           fill="none"
                           stroke-width="1.8"
                           stroke-linecap="round"
                           stroke-linejoin="round"
                         >
                           <rect x="4" y="4" width="16" height="16" rx="2" />
                           <path d="M9 2v4" />
                           <path d="M15 2v4" />
                           <path d="M9 18v4" />
                           <path d="M15 18v4" />
                           <circle cx="12" cy="12" r="3" />
                         </svg>
                         Reliable Platform
                       </div>
         
                       <div class="feature">
                         <svg
                           viewBox="0 0 24 24"
                           fill="none"
                           stroke-width="1.8"
                           stroke-linecap="round"
                           stroke-linejoin="round"
                         >
                           <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                           <path d="m9 12 2 2 4-4" />
                         </svg>
                         Secure Access
                       </div>
                     </div>
         
                     <div class="illustration" aria-hidden="true">
                       <img
                         src="/illustration.png"
                         width="475px"
                         height="400px"
                       />
                     </div>
                   </div>
         
                   <div class="login-card">
                     <h2>Welcome</h2>
         
                     <p class="subtitle">
                       One-stop platform for comprehensive tax solutions
                     </p>
         
                      {/* {status ? (
                        <Alert variant="outlined" severity="success">
                           {status}
                         </Alert>   
                     ) :  */}
                     
                     <SignupContainer/>
                         
                     <p className="forgot" style={{textDecoration : "none"}}>
                       Have an account? <Link to="/">Sign in</Link>
                     </p>   
         
                   </div>
                 </section>
         
                 <div class="floating-ball" aria-hidden="true">
                   <img
                     src="/ball.png"
                     width="150px"
                     height="150px"
                   />
                 </div>
                 <div class="sparkle" aria-hidden="true"></div>
               </div>
             </div>
  );
};

export default Login;
